import * as React from 'react';
import cn from 'clsx';
import { ArticleParagraph1, Image, ArticleParagraph2 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

import { withDeviceType, IWithDeviceTypeProps } from '../../../utils/withDeviceType';
import { IDealDetailInfo } from '../../../types/promoInfo';
import { ListWithIcons } from '../../ListWithIcons';

import * as styles from './styles.css';

interface ICommonDealDetailsContentProps extends IWithDeviceTypeProps {
  content: IDealDetailInfo;
}

/**
 * Модалка с часто встречающейся информацией о сделке.
 */
const CommonDealDetailsContent: React.FC<React.PropsWithChildren<ICommonDealDetailsContentProps>> = ({
  content,
  isPhone,
  deviceType,
}) => {
  const { description, details, notificationIcon, notificationText } = content;

  return (
    <>
      {description && <ArticleParagraph1 whiteSpace="pre-wrap">{description}</ArticleParagraph1>}
      {details?.length && (
        <ListWithIcons.List>
          {details.map((detail, i) => (
            <ListWithIcons.Item key={i}>{detail}</ListWithIcons.Item>
          ))}
        </ListWithIcons.List>
      )}
      {notificationText && (
        <div className={cn(styles['notification'], styles[deviceType])}>
          {notificationIcon && (
            <div className={styles['icon']}>
              <Image src={notificationIcon} width={40} height={40} objectFit="contain" loading="lazy" />
            </div>
          )}
          <ConditionalWrapper if={isPhone} ThenComponent={ArticleParagraph2} ElseComponent={ArticleParagraph1}>
            {notificationText}
          </ConditionalWrapper>
        </div>
      )}
    </>
  );
};

const CommonDealDetailsContentWithDeviceType = withDeviceType(CommonDealDetailsContent);
export { CommonDealDetailsContentWithDeviceType as CommonDealDetailsContent };
